import { Button, Pagination, Typography } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileLines } from "@fortawesome/pro-duotone-svg-icons";
import dayjs from "dayjs";
import { useState, ChangeEvent, useEffect } from "react";
import "./styles.css";
import DefaultButton from "../../../../components/Accessibility/DefaultButton";
import PageTitle from "../../../../components/Accessibility/PageTitle";
import DateInput from "../../../../components/DateInput";
import LoadingApp from "../../../../components/LoadingApp";
import { useAccessibility } from "../../../../Store/contexts/AccessibilityContext";
import { getMinhasSolicitacoes } from "../../../../services/Financeiro/OutrasSolicitacoes";
import { downloadBase64File } from "../../../../utils/DownloadFile";
import {
  sxButtonText,
  sxDateInputSolicitacoes,
  sxLabelSolicitacoes,
  sxPaginationSolicitacoes,
  sxStatusTextSolicitacoes,
  sxValidationMessageSolicitacoes,
} from "./sxProps";
import { sxPaginationContrast } from "../../../../assets/styles/CommonSxProps";
import BackButton from "../../../../components/BackButton";
import { useLocation } from "react-router-dom";

const MinhasSolicitacoes = () => {
  const [mySolicitacoes, setMySolicitacoes] = useState<any[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [page, setPage] = useState<number>(1);
  const [errors, setErrors] = useState({
    dataInicio: "",
    dataFim: "",
  });
  const [dataInicio, setDataInicio] = useState<string>("");
  const [dataFim, setDataFim] = useState<string>("");

  // Get para solicitações
  const location = useLocation();

  useEffect(() => {
    const getMySolicitacoes = async () => {
      setLoading(true);
      const result = await getMinhasSolicitacoes();
      if (result != null) {
        setMySolicitacoes(result);
      }
      setLoading(false);
    };
    getMySolicitacoes();
  }, [location.state?.reload, location.state?.timestamp]);

  const accessibility = useAccessibility();

  const handleDateChange = (
    field: "dataInicio" | "dataFim",
    newDate: Date | null
  ) => {
    const formattedDate = newDate ? dayjs(newDate).format("DD/MM/YYYY") : "";
    if (field === "dataInicio") {
      setDataInicio(formattedDate);
    } else {
      setDataFim(formattedDate);
    }
  };

  const paginatedSolicitacoes = mySolicitacoes.slice((page - 1) * 5, page * 5);

  const handlePageChange = (event: ChangeEvent<unknown>, newPage: number) => {
    setPage(newPage);
  };


  return (
    <div className="minhas-solicitacoes-container">
      <PageTitle text="Minhas solicitações" className="solicitacoes-title" />

    {/* Gerar Relatório */}
      {/* <div className="solicitacoes-form-container">
        <div>
          <Typography
            style={accessibility.textStyleAccessibility}
            sx={sxLabelSolicitacoes}
          >
            Data início
          </Typography>
          <div className="input-container">
            <DateInput
              label={`Data início ${errors.dataInicio ?? ""}`}
              slotProps={{
                textField: {
                  placeholder: "01/01/2000",
                  error: !!errors.dataInicio,
                  sx: sxDateInputSolicitacoes,
                },
              }}
              onChange={(newDate) => handleDateChange("dataInicio", newDate)}
              maxDate={dayjs()}
            />
          </div>
          <div
            className="validation-message-container"
          >
            {errors.dataInicio && (
              <Typography
                sx={sxValidationMessageSolicitacoes}
                style={accessibility.textStyleAccessibility}
              >
                {errors.dataInicio}
              </Typography>
            )}
          </div>
        </div>

        <div>
          <Typography
            style={accessibility.textStyleAccessibility}
            sx={sxLabelSolicitacoes}
          >
            Data fim
          </Typography>
          <DateInput
            label={`Data fim ${errors.dataFim ?? ""}`}
            slotProps={{
              textField: {
                placeholder: "01/01/2000",
                error: !!errors.dataFim,
              },
            }}
            onChange={(newDate) => handleDateChange("dataFim", newDate)}
            maxDate={dayjs()}
          />
          <div
            className="validation-message-container"
          >
            {errors.dataFim && (
              <Typography
                sx={sxValidationMessageSolicitacoes}
                style={accessibility.textStyleAccessibility}
              >
                {errors.dataFim}
              </Typography>
            )}
          </div>
        </div>

        <DefaultButton
          text="GERAR RELATÓRIO"
          onClick={() => console.log("Buscando solicitações...")}
          disabled={!dataInicio || !dataFim}
        />
      </div> */}

      <div className="minhas-solicitacoes-list">
        <LoadingApp showLoading={loading} />
        {mySolicitacoes.length === 0 ? (
          <h1
            className="empty-solicitacoes-info"
            style={accessibility.textStyleAccessibility}
          >
            Nenhuma solicitação cadastrada.
          </h1>
        ) : (
          <div className="minhas-solicitacoes-cards-list">
            {paginatedSolicitacoes.map((solicitacao) => (
              <div
                key={solicitacao.id}
                className="minhas-solicitacoes-card-holder"
                style={{
                  ...accessibility.contrastStyle,
                  ...accessibility.contrastBorderAccessibility,
                }}
              >
                <div className="minhas-solicitacoes-card-icon">
                  <FontAwesomeIcon
                    style={accessibility.contrastColorAccessibility}
                    icon={faFileLines}
                    className="minhas-solicitacoes-icon"
                  />
                </div>
                <div className="minhas-solicitacoes-card-info">
                  <span
                    style={accessibility.textStyleAccessibility}
                    className="minhas-solicitacoes-info"
                  >
                    <b>Nome:</b> {solicitacao.txtSolicit}
                  </span>
                  <span
                    style={accessibility.textStyleAccessibility}
                    className="minhas-solicitacoes-info"
                  >
                    <b>Protocolo:</b> {solicitacao.protocAns}
                  </span>
                  <span
                    style={accessibility.textStyleAccessibility}
                    className="minhas-solicitacoes-info"
                  >
                    <b>Data da solicitação:</b> {solicitacao.dtIncl}
                  </span>
                  <span
                    style={accessibility.textStyleAccessibility}
                    className="minhas-solicitacoes-info"
                  >
                    <b>Descrição:</b> {solicitacao.descr}
                  </span>
                  <div className="minhas-solicitacoes-anexos">
                    <span className="minhas-solicitacoes-info">
                      <b
                        style={{
                          color: accessibility.contrastMode
                            ? "white"
                            : "#383838",
                        }}
                      >
                        Anexos:
                      </b>
                    </span>
                    <div className="anexos-list">
                      {solicitacao.anexosSolic?.map((anexo : any) => (
                        <Typography
                          style={{
                            ...accessibility.textStyleAccessibility,
                            color: accessibility.contrastMode ? "#fff" : "#383838",
                            fontWeight: 300,
                            padding: 0,
                            marginRight: 8,
                          }}
                          sx={sxButtonText}
                        >
                          {anexo.nome}
                        </Typography>
                      ))}
                    </div>
                  </div>
                  <span
                    style={{ ...accessibility.textStyleAccessibility }}
                    className="minhas-solicitacoes-info"
                  >
                    <b
                      style={{
                        color: accessibility.contrastMode ? "white" : "#383838",
                      }}
                    >
                      Status:
                    </b>{" "}
                    <Typography
                      component="span"
                      sx={sxStatusTextSolicitacoes(
                        solicitacao.descr,
                        accessibility.contrastMode
                      )}
                    >
                      {solicitacao.descr}
                    </Typography>
                  </span>
                </div>
              </div>
            ))}
            {mySolicitacoes.length > 5 && (
              <div className="pagination-holder">
                <Pagination
                  count={Math.ceil(mySolicitacoes.length / 5)}
                  sx={
                    accessibility.contrastMode
                      ? sxPaginationContrast
                      : sxPaginationSolicitacoes
                  }
                  hideNextButton
                  hidePrevButton
                  color="primary"
                  page={page}
                  onChange={handlePageChange}
                />
              </div>
            )}
            <BackButton
              route={"/financeiro/outrasSolicitacoesFinanceiras"}
              ariaLabel="voltar para menu de outras solicitações financeiras"
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default MinhasSolicitacoes;
